import { TReadyBusinessGroupItem, TBusinessPossibleAppointmentItem } from '../../types';

export const getItemById = (
  itemId: number,
  groups: TReadyBusinessGroupItem[],
): TBusinessPossibleAppointmentItem | undefined => {
  for (const group of groups) {
    for (const item of group.items) {
      if (item.id === itemId) {
        return item;
      }
    }
  }

  return undefined;
};
